import { createSlice } from "@reduxjs/toolkit";
import { AUTH_LOCALSTORAGE_NAME } from "../../constants/constants";
import { AuthInitialState } from "../../types";

const initialState: AuthInitialState = {
  access_token: undefined,
  user: undefined,
  role: undefined,
  showModalDashboard: true,
  notificationToken: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLoggedIn: (state, action) => {
      state.access_token = action.payload?.access_token;
      state.user = action.payload?.user;
      state.role = action.payload?.role;
    },
    userLoggedOut: (state) => {
      state.access_token = undefined;
      state.user = undefined;
      state.role = undefined;
      localStorage.removeItem(AUTH_LOCALSTORAGE_NAME);
    },
    setSuccessSignup: (state, action) => {
      state.isSuccessSignup = action.payload;
    },
    setShowModal: (state, action) => {
      state.showModalDashboard = action.payload;
    },
    setNotificationToken: (state, action) => {
      state.notificationToken = action.payload;
    },
  },
});

export const {
  userLoggedIn,
  userLoggedOut,
  setSuccessSignup,
  setShowModal,
  setNotificationToken,
} = authSlice.actions;
export default authSlice.reducer;
